import React from "react";
import { useTranslation } from "react-i18next";
import { Rating } from "@sbi-international/boutik.gatsby.plugin.components";
import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { ProductReviewsModel } from "../../../models/productReviewsModel";

type ProductSummaryHeaderProps = {
    setDetailsBox: (arg: string) => void;
    scrollToReviews: () => void;
    productReviews: ProductReviewsModel | null;
    product: Queries.ProductsJson;
};

export default function ProductSummaryHeader(props: ProductSummaryHeaderProps) {
    const { setDetailsBox, scrollToReviews, product, productReviews } = props;
    const { currentLocale } = usePageLocalization();
    const { t } = useTranslation("templatePages");

    const productCode = product.code ? (product.code as string) : "";

    const scrollToReviewsAction = () => {
        setDetailsBox("reviews");
        scrollToReviews();
    };

    return (
        <>
            {productCode != "" && (
                <div className="summaryHeader">
                    {product.title && (
                        <h1 className="productTitle">
                            {product.title[currentLocale]}{" "}
                            <span className="productCategory">
                                {product.category?.includes("Wood Stoves")
                                    ? t("stove")
                                    : t("insert")}
                            </span>
                        </h1>
                    )}

                    <span className="productCode">{productCode}</span>

                    <div className="header-summary-review">
                        {productReviews && productReviews?.count > 0 ? (
                            <>
                                <Rating.RatingScore
                                    ratingScore={productReviews?.average as number}
                                    ratingCount={productReviews?.count}
                                />
                                <div
                                    className="header-summary-review-child header-summary-review-view-all hover-dark-to-light"
                                    onClick={scrollToReviewsAction}
                                >
                                    {t("view-all-reviews")}
                                </div>
                            </>
                        ) : (
                            <span
                                onClick={scrollToReviewsAction}
                                className="header-summary-review-child header-summary-review-view-be-first hover-dark-to-light"
                            >
                                {t("be-first-review")}
                            </span>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}
